import {AssignmentCompensationCard} from '@features/assignment/components/assignment-compensation-card'
import {AssignmentHostCard} from '@features/assignment/components/assignment-host-card'
import {AssignmentHostInstructionsCard} from '@features/assignment/components/assignment-host-instructions-card'
import {AssignmentNotesCard} from '@features/assignment/components/assignment-notes-card'
import {AssignmentScheduledDate} from '@features/assignment/components/assignment-scheduled-date'
import {Assignment} from '@features/assignment/types'
import {ASSIGNMENT_CARD_WRAPPER_CLASSNAME} from '../constants'
import {AssignmentUpworkCompensationCard} from './assignment-upwork-compensation-card'
import {TASK_CATEGORY_REVIEW} from '@features/assignment/utils.tsx'

export const AssignmentWalkthroughCards = ({assignment}: {assignment: Assignment}) => {
    const isUpworkPayment = assignment?.is_paid_via_upwork
    const isReview = assignment.task_category.name === TASK_CATEGORY_REVIEW
    const isReviewCompleted = isReview && assignment.task_status.status == 'completed'

    return (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {assignment.status != 'pending' && (
                <div className="flex flex-col gap-6 w-full">
                    {assignment.task_status.status == 'pending_assets' && (
                        <div className={ASSIGNMENT_CARD_WRAPPER_CLASSNAME}>
                            <AssignmentScheduledDate date={assignment.to_shoot_at} />
                        </div>
                    )}
                    {!isReview && <AssignmentNotesCard assignment={assignment} />}
                </div>
            )}

            <div className="flex flex-col gap-6 w-full">
                {!isReview &&
                    (isUpworkPayment ? (
                        <AssignmentUpworkCompensationCard />
                    ) : (
                        <AssignmentCompensationCard assignment={assignment} />
                    ))}
                {assignment.status != 'pending' && !isReviewCompleted && (
                    <>
                        <AssignmentHostCard />
                        {!!assignment.instructions && <AssignmentHostInstructionsCard assignment={assignment} />}
                    </>
                )}
            </div>
        </div>
    )
}
